export default "__VITE_ASSET__BMKQEDWI__"